// UI-WORKBENCH-1 (2026-05-07) — Three-panel command-center layout primitive
// per memo §15.2.  Used by Workbench v1; future Operations console (Phase 4)
// reuses the same primitive.
//
// Children pattern: pass `rail`, `grid`, `preview` JSX as props.  Any of the
// three may be null/undefined; the layout collapses gracefully via the
// .no-rail / .no-preview modifier classes.
//
// Sizing tokens come from styles.js CSS variables (--rail-width, --preview-width).
// The grid panel is a 1fr center column that absorbs leftover horizontal space.
//
// Responsive: <768px collapses to grid-only (rail + preview hidden).  v1 ships
// with the desktop-first layout; mobile is out of scope per UI_INCORPORATION_PLAN.md §6.
export default function CommandCenter({ rail, grid, preview }) {
  const cls = "command-center"
    + (!rail    ? " no-rail"    : "")
    + (!preview ? " no-preview" : "");
  return (
    <div className={cls}>
      {rail    && <div className="cc-rail">{rail}</div>}
      {grid    && <div className="cc-grid">{grid}</div>}
      {preview && <div className="cc-preview">{preview}</div>}
    </div>
  );
}
